import { GTMPurchasedAccommodationItem } from "@/helpers/gtm/GTMAccommodationItem.ts";
import { GTMEvent } from "@/helpers/gtm/GTMEvent.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import TagManager from "react-gtm-module";
import { useShallow } from "zustand/react/shallow";

export const useGTMPurchase = () => {
  const { cartAccommodationItems, calculatedCartData } = useEngineStore(
    useShallow((state) => ({
      cartAccommodationItems: state.cartAccommodationItems,
      calculatedCartData: state.calculatedCartData,
    })),
  );

  return (reservationID: string) => {
    const purchasedItems = cartAccommodationItems?.map((cartItem, index): GTMPurchasedAccommodationItem => {
      const RP = cartItem.ratePlan;
      const RG = cartItem.ratePlan.rateGroup;

      const breakfastCount = cartItem.optionalExtras?.filter((e) => e.name === "Dodatan doručak")?.length;
      const carCount = cartItem.optionalExtras?.filter((e) => e.name === "Dodatan auto")?.length;
      const petCount = cartItem.optionalExtras?.filter((e) => e.name === "Kućni ljubimac")?.length;
      const babyGearCount = cartItem.optionalExtras?.filter((e) => e.name === "Oprema za bebe")?.length;
      const adults = cartItem.adults?.length;
      const children = cartItem.children?.length;

      return {
        item_id: RP.id,
        item_name: RP.name,
        currency: "EUR",
        price: RP.lowestPrice,
        item_category: RG.name,
        index,
        quantity: 1,

        breakfast: breakfastCount,
        baby_gear: babyGearCount,
        car: carCount,
        pets: petCount,
        adults,
        children,
      };
    });

    const sojournTaxMandatoryExtras = cartAccommodationItems
      ?.flatMap((item) => item.mandatoryExtras)
      ?.filter((extra) => extra?.name === "Boravišna pristojba (odrasli)");
    const totalSojournTax = sojournTaxMandatoryExtras.reduce((acc, item) => acc + item.price, 0);

    const checkInFeeMandatoryExtras = cartAccommodationItems
      ?.flatMap((item) => item.mandatoryExtras)
      ?.filter((extra) => extra?.name === "Jednokratna prijava smještaja");
    const totalCheckInFee = checkInFeeMandatoryExtras.reduce((acc, item) => acc + item.price, 0);

    TagManager.dataLayer({ dataLayer: { ecommerce: null } });
    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.Purchase,
        ecommerce: {
          currency: "EUR",
          value: calculatedCartData?.priceBreakdown?.withDiscount,

          transaction_id: reservationID,
          sojourn_tax: totalSojournTax,
          check_in_fee: totalCheckInFee,

          items: purchasedItems,
        },
      },
    });
  };
};
